module.exports = __webpack_public_path__ + "img/beginning.3ba1947c.png";